/*
 * Cart auto-open bridge — global. When a visitor is redirected away from a
 * disabled cart page (see cart-redirect.js sets sessionStorage 'oilogic:open-cart'),
 * this reads the flag on the destination page and opens the drawer by
 * dispatching the same public event an add-to-cart uses. Dispatching on
 * DOMContentLoaded guarantees <oilogic-cart-drawer> has registered its listener
 * (all defer scripts run first). The flag is one-shot: cleared on read.
 */
(() => {
  let flagged = false;
  try {
    flagged = !!sessionStorage.getItem('oilogic:open-cart');
  } catch (e) {
    return;
  }
  if (!flagged) return;
  try {
    sessionStorage.removeItem('oilogic:open-cart');
  } catch (e) {
    /* ignore */
  }

  const open = () =>
    document.dispatchEvent(new CustomEvent('oilogic:cart:added', { bubbles: true, detail: {} }));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', open, { once: true });
  } else {
    open();
  }
})();
